import { render } from "./AddEditSlide.vue?vue&type=template&id=54799ee1&scoped=true"
import script from "./AddEditSlide.vue?vue&type=script&lang=js"
export * from "./AddEditSlide.vue?vue&type=script&lang=js"

import "./AddEditSlide.vue?vue&type=style&index=0&id=54799ee1&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54799ee1"]])

export default __exports__